import {
  FETCH_ROUTING_SCHEDULE_REQUEST,
  FETCH_ROUTING_SCHEDULE_SUCCESS,
  FETCH_ROUTING_SCHEDULE_FAILURE,
  SET_ROUTING_SCHEDULE_FILTER,
  RESET_ROUTING_FILTERS,
} from 'Constants/redux';
import service from 'Api/service';
import axios from 'axios';
import moment from 'moment-timezone';
import { setErrors } from './dashboardActionCreators';
import { routingTimeZone } from 'Components/routing/shared/useRoutingTimeZone';

let scheduleRequestCancelSource = null;

const getScheduleMonthKey = (date) =>
  `${date.getFullYear()}-${date.getMonth()}`;

export function setRoutingScheduleFilter(filter) {
  return {
    type: SET_ROUTING_SCHEDULE_FILTER,
    payload: { filter },
  };
}

export const loadRoutingSchedule = (prioritize_sticky = false) => {
  return (dispatch, getState) => {
    const {
      startDate,
      truckIds,
      employeeIds,
      transportType,
      rentalStatus,
    } = getState().operation.operationsFilter;
    dispatch({
      type: FETCH_ROUTING_SCHEDULE_REQUEST,
    });
    // The month's bounds in the routing zone, so they follow it once it is selectable (TD1-6729).
    const timeZone = routingTimeZone();
    const month = moment.tz(
      [startDate.getFullYear(), startDate.getMonth(), 1],
      timeZone
    );
    const startDateTimeGte = month.toDate(); // Beginning of the month
    const startDateTimeLte = month.clone().endOf('month').startOf('second').toDate(); // End of the month

    const requestedMonthKey = getScheduleMonthKey(startDate);

    if (scheduleRequestCancelSource) {
      scheduleRequestCancelSource.cancel('New routing schedule month selected');
    }
    const currentSource = axios.CancelToken.source();
    scheduleRequestCancelSource = currentSource;
    const cancelToken = currentSource.token;

    service
      .get(import.meta.env.VITE_API_DOMAIN + '/api/routing_schedule_reports', {
        start_date_time_gte: startDateTimeGte,
        start_date_time_lte: startDateTimeLte,
        truck_ids: truckIds,
        employee_ids: employeeIds,
        transport_type: transportType,
        rental_status: rentalStatus,
        time_zone: timeZone,
      }, { cancelToken })

      .then((response) => {
        const currentStartDate =
          getState().operation.operationsFilter.startDate;

        if (getScheduleMonthKey(currentStartDate) !== requestedMonthKey) {
          return;
        }

        dispatch({
          type: FETCH_ROUTING_SCHEDULE_SUCCESS,
          payload: {
            dataSet: response.data.data,
          },
        });
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return;
        }

        const currentStartDate =
          getState().operation.operationsFilter.startDate;

        if (getScheduleMonthKey(currentStartDate) !== requestedMonthKey) {
          return;
        }

        dispatch(setErrors(error.response?.data ?? error));
        dispatch({ type: FETCH_ROUTING_SCHEDULE_FAILURE });
      })
      .finally(() => {
        if (scheduleRequestCancelSource === currentSource) {
          scheduleRequestCancelSource = null;
        }
      });
  };
};

export function resetRoutingFilters() {
  return (dispatch, getState) => {
    dispatch({
      type: RESET_ROUTING_FILTERS,
    });
  };
}

export function setRoutingScheduleFilterAndReload(filter) {
  return (dispatch, getState) => {
    dispatch(setRoutingScheduleFilter(filter));
    dispatch(loadRoutingSchedule());
  };
}
